module.exports = __webpack_public_path__ + "img/2025-11-17b_1.da856676.jpg";